import {createElement} from 'react';

export const MyContainerWithCondition = ({isWrap, as = 'div', className, children, ...props}) => {
	
	
	
	return isWrap ? createElement(as, {className, ...props}, children) : children;
}